module.exports = __webpack_public_path__ + "static/media/bgr-featured-carriers.ace9985b.webp";